module.exports = __webpack_public_path__ + "static/media/realtors-icon-8.5674b153.svg";